export default __webpack_public_path__ + "static/media/kik-vagyunk-mi.5aa556be.jpg";